import errorGraphic from '../../assets/icons/error-graphic.svg';
import tetherfiLogo from '../../assets/icons/tetherfi-logo.svg';
import './index.scss';

const packageInfo = require('../../../package.json');

interface IErrorPageProps {
    message: string | null,
}

export const ErrorPage = (props: IErrorPageProps) => {
    return <div className='error-page-container'>
        <div className='error-page-logo-1-container'>
            <img src={tetherfiLogo} alt='' />
        </div>
        <div className='error-page-logo-2-container'>
            <img src={errorGraphic} alt='' />
        </div>
        <div className='error-page-message-container'>
            <span>{props.message ?? ''}</span>
        </div>
        <div className='version-container'>
            <span>{packageInfo.version}</span>
        </div>
    </div>
}